import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import axios from "axios";
import { IMAGES } from "../data/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WeeklyColumn = () => {
  const [articles, setArticles] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/articles`, { params: { category: "weekly-column" } })
      .then((r) => setArticles(r.data))
      .catch(() => setArticles([]));
  }, []);

  return (
    <section
      id="column"
      data-testid="weekly-column-section"
      className="py-28 md:py-40 px-6 md:px-12 max-w-[1400px] mx-auto"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
        <div className="lg:col-span-4">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="lg:sticky lg:top-32"
          >
            <p className="text-xs tracking-[0.35em] uppercase text-samatva-plum mb-6">
              Samatva Weekly Column
            </p>
            <h2 className="font-serif text-4xl sm:text-5xl font-light tracking-tight text-samatva-ink leading-[1.05]">
              Every Thursday, a new perspective on{" "}
              <em className="text-samatva-plum">well-being..</em>
            </h2>
            <div className="mt-10 overflow-hidden rounded-t-full rounded-b-[2rem] aspect-[3/4] max-w-[240px]">
              <img
                src={IMAGES.tea}
                alt="A young sapling growing from ancient temple stone at sunrise"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              />
            </div>
          </motion.div>
        </div>

        <div className="lg:col-span-8">
          {articles && articles.length === 0 && (
            <motion.p
              data-testid="column-coming-soon"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
              className="font-serif text-3xl md:text-5xl font-light leading-snug text-samatva-ink/70 max-w-xl"
            >
              The first <em className="text-samatva-plum">Tattva Bodh</em>{" "}
              article will arrive here soon..
            </motion.p>
          )}

          {(articles || []).map((a, i) => (
            <motion.div
              key={a.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
            >
              <Link
                to={`/column/${a.slug}`}
                data-testid={`column-article-${i + 1}`}
                className="group block border-b border-samatva-line py-10 first:pt-0 hover:bg-samatva-peach/30 transition-colors duration-300 -mx-4 px-4 rounded-lg"
              >
                <div className="flex items-baseline justify-between gap-4">
                  <span className="text-xs tracking-[0.2em] uppercase text-samatva-plum">
                    Samatva Weekly
                  </span>
                  {a.publish_date && (
                    <span className="text-xs text-samatva-muted">
                      {a.publish_date}
                    </span>
                  )}
                </div>
                <div className="mt-3 flex items-center gap-3">
                  <h3 className="font-serif text-2xl md:text-4xl font-light text-samatva-ink group-hover:text-samatva-plum transition-colors duration-300">
                    {a.title}
                  </h3>
                  <ArrowRight
                    size={22}
                    className="shrink-0 text-samatva-plum opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300"
                  />
                </div>
                {a.subtitle && (
                  <p className="mt-2 font-serif text-lg italic text-samatva-plum/80">
                    {a.subtitle}
                  </p>
                )}
                {a.author && (
                  <p className="mt-2 text-xs tracking-[0.2em] uppercase text-samatva-muted">
                    By {a.author}
                  </p>
                )}
                <p className="mt-4 text-sm md:text-base font-light leading-relaxed text-samatva-muted max-w-2xl">
                  {a.body.split(/\n\n+/)[0].slice(0, 220)}…
                </p>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
